<template>
  <div class = "afdc-form-group">
    <label class="afdc-sr-only" for="afdc-state-select">{{ $t('States') }}</label>
    <select class ="afdc-custom-select" id="afdc-state-select" v-model="selectedState">
      <option value="all">
        All states
      </option>
      <option v-for="state in states" v-bind:key="state.abbrev" v-bind:value="state.abbrev">
        {{state.name}}
      </option>
    </select>
  </div>
</template>

<script>
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  name: 'StateFilter',

  computed: {
    validStateCodes() {
      return this.allStates.map((state) => state.abbrev);
    },
    states() {
      return this.$store.getters.getStateGeoData;
    },
    allStates() {
      return this.$store.getters.getAllStateGeo;
    },
    selectedState: syncInputRouteQuery('state'),
  },
  watch: {
    allStates: {
      immediate: true,
      handler: 'setState',
    },

    selectedState: {
      immediate: true,
      handler: 'setState',
    },
  },
  methods: {
    setState() {
      if (this.allStates.length >= 1) {
        // this gets the bounds for a selected state in the route if it is a valid state code, if invalid it clears the query
        const hasValidState = this.validStateCodes.includes(this.selectedState) || this.selectedState === 'all';
        if (hasValidState) {
          this.$store.commit('setCorridorState');
        } else if (this.$route.query.state) {
          this.$router.push({ query: { ...this.$route.query, state: undefined } });
        }
      }
    },
  },
};

</script>
